<template>
  <van-popup
    v-model="visible"
    position="bottom"
    :close-on-click-overlay="false"
    @click-overlay="close"
    safe-area-inset-bottom
  >
    <img
      src="@/assets/lucky/icon_close.png"
      alt=""
      class="close"
      @click="close"
    />
    <div class="title"></div>
    <div class="total">
      <span>我的可用抽奖券：</span>
      <span class="num">共{{ total }}张</span>
    </div>
    <div class="tabbar">
      <div
        v-for="(tab, i) of tabs"
        class="item"
        :key="i"
        :class="{ active: active == i }"
        @click="changeTab(i)"
      >
        {{ tab.label }}
      </div>
    </div>
    <div class="scroll">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="发生异常，请刷新！"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="item" v-for="(item, i) of list" :key="i">
          <div class="info">
            <span v-if="active" class="title">参与抽奖活动</span>
            <span v-else class="title">{{ item._title }}</span>
            <span v-if="active" class="date"
              >使用时间：{{ item.created_at }}</span
            >
            <span v-else class="date">发放日期：{{ item._date }}</span>
          </div>
          <span v-if="active" class="num">-{{ item.ticket }}</span>
          <span v-else class="num">+{{ item.ticket }}</span>
        </div>
      </van-list>
    </div>
  </van-popup>
</template>

<script>
import { getFmtDate } from "./utils";

const typeMap = {
  1: "三年购下单抽奖券",
  2: "开通vip抽奖券",
  3: "城市代理人抽奖券",
  4: "商品开奖失败返还",
};

export default {
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    total: Number,
  },
  data() {
    return {
      active: 0,
      tabs: [
        {
          label: "已获取",
        },
        {
          label: "已使用",
        },
      ],
      loading: false,
      finished: false,
      error: false,
      page: 0,
      list: [],
    };
  },
  watch: {
    visible(e) {
      if (e) {
        this.onRefresh();
      }
    },
  },
  methods: {
    close() {
      this.$emit("visibleChange", false);
    },
    changeTab(e) {
      this.active = e;
      this.onRefresh();
    },
    onRefresh() {
      this.finished = false;
      this.error = false;
      this.loading = true;
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    onLoad() {
      if (this.finished) {
        return;
      }
      this.$api
        .post("activity/member/lucky/my-ticket", {
          page: ++this.page,
          pageSize: 10,
          type: this.active ? 3 : 1,
        })
        .then((res) => {
          res = res.ticket_list;
          res.data.forEach((_) => {
            _._title = typeMap[_.get_type];
            _._date = getFmtDate(_.created_at, "Y-m-d");
          });
          if (this.page == 1) {
            this.list = res.data;
          } else {
            this.list = this.list.concat(res.data);
          }
          console.log("抽奖券", this.list);
          this.finished = res.current_page >= res.last_page;
        })
        .catch((e) => (this.error = true))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="less" scoped>
.bg-img {
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.van-popup {
  height: 60vh;
  border-radius: 1.2rem 1.2rem 0 0;
  overflow: hidden;
  background: #fef9f3;
  border: 0.1rem solid #ffd9b7;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.2rem;

  .close {
    position: absolute;
    width: 2.4rem;
    height: 2.4rem;
    top: 1.1rem;
    right: 0.9rem;
  }

  & > .title:extend(.bg-img) {
    width: 19.3rem;
    height: 3.5rem;
    background-image: url(~@/assets/lucky/ticket_title.png);
  }

  .total {
    color: #4a1500;
    margin-top: 0.9rem;

    .num {
      font-weight: 700;
    }
  }

  .tabbar {
    margin-top: 0.8rem;
    align-self: stretch;
    height: 3.4rem;
    background: #fff1e0;
    display: flex;
    align-items: stretch;
    padding: 0.2rem;

    .item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #885a47;
      font-size: 1.3rem;

      &.active {
        color: #4a1500;
        font-weight: 700;
        background: #fffdfb;
        border-radius: 0.4rem;
      }
    }
  }

  .scroll {
    align-self: stretch;
    flex: 1;
    overflow: auto;
    margin-top: 1.5rem;

    .item {
      margin-top: 1.2rem;
      padding: 1.4rem 1.1rem;
      background: #fffdfb;
      border: 0.1rem solid #f9edef;
      border-radius: 0.4rem;
      display: flex;
      align-items: center;

      &:first-of-type {
        margin: 0;
      }

      .info {
        display: flex;
        flex-direction: column;
        flex: 1;

        .title {
          font-size: 1.5rem;
          color: #4a1500;
          font-weight: 700;
        }

        .date {
          color: #885a47;
          font-size: 1.1rem;
          margin-top: 0.2rem;
        }
      }

      .num {
        font-size: 2rem;
        color: #f9305b;
      }
    }
  }
}
</style>
